module.exports = __webpack_public_path__ + "static/img/fr.001ca656.png";